// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"4cc119f7","487":"c0ef6f56"}[chunkId] + ".chunk.css";
};